import { EPISODES, isPublishedEpisode } from 'shared/data/episodes';
import type { PublishedEpisode } from 'shared/data/episodes';

export function getEpisodeByNumber(episodeNumber: string): PublishedEpisode | undefined {
  return EPISODES.filter((episode): episode is PublishedEpisode => isPublishedEpisode(episode))
    .find((episode) => episode.number === episodeNumber);
}

export function getEpisodesByNumbers(episodeNumbers: string[]): PublishedEpisode[] {
  return episodeNumbers
    .map((number) => getEpisodeByNumber(number))
    .filter((episode): episode is PublishedEpisode => episode !== undefined);
}

export function getRandomEpisodes(count: number, excludeEpisodeNumber: string): PublishedEpisode[] {
  const candidates = EPISODES.filter(
    (episode): episode is PublishedEpisode =>
      episode.number !== excludeEpisodeNumber
  );
  const shuffled = [...candidates].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

export const getPublishedEpisodes = (): PublishedEpisode[] => {
  return EPISODES.filter((episode): episode is PublishedEpisode => isPublishedEpisode(episode))
}

export const hasPublishedEpisodes = (): boolean => {
  return EPISODES.findIndex(episode => !episode.upcoming) > -1
}
